module.exports = __webpack_public_path__ + "static/media/wonder-blocks.2c593a32.png";